export default __webpack_public_path__ + "static/media/adeyemon_peter.a6ad796a.jpg";